import React from "react";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const claimed = Math.round((TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100);
  return <div className="mt-7 rounded-2xl bg-rose-50 p-4 ring-1 ring-rose-200" data-id="element-350" data-mp="2xzpu7kvsx403">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-extrabold text-rose-700" data-id="element-351" data-mp="2sz28neqcdfd9">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-352" data-mp="37w1eax1muy53" />
        Only {SPOTS_LEFT} spots left at the promotional price!
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-rose-100" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-353" data-mp="32vndo02d2qh3">
        <div className="h-full rounded-full bg-rose-600" style={{
        width: `${claimed}%`
      }} data-id="element-354" data-mp="3qmiy2c4hmjeb" />
      </div>
      <p className="mt-2 flex justify-between text-xs font-bold uppercase tracking-wide text-rose-700/80" data-id="element-355" data-mp="3lpahuh2wgpfp">
        <span data-id="element-356" data-mp="yiy63hlmo8lj">{claimed}% claimed</span>
        <span data-id="element-357" data-mp="yjzhxoagwz4b">Price goes up soon</span>
      </p>
    </div>;
}